<p>calculation-profitability works!</p>
